import {
    AdaptadorAgrupamentoRelatorio,
    derivarGroupingModel,
    podeExpandirGrupoTerminal,
} from '../PontoDiario/contrato-agrupamento'
import { explodirLinhas, LinhaExplodidaDSR } from './explodir-linhas'
import {
    CAMPO_POR_NIVEL,
    DescontoDSRItem,
    LABEL_NIVEL,
    NivelDSR,
    ORDEM_NIVEIS_CLIENTE,
    ORDEM_NIVEIS_FUNCIONARIO,
} from './niveis-agrupamento'

export const adaptadorDsrCliente: AdaptadorAgrupamentoRelatorio<
    NivelDSR,
    DescontoDSRItem,
    LinhaExplodidaDSR
> = {
    niveisValidos: ORDEM_NIVEIS_CLIENTE,
    ordemNiveis: ORDEM_NIVEIS_CLIENTE,
    labelNivel: LABEL_NIVEL,
    campoPorNivel: CAMPO_POR_NIVEL,
    obterGroupingModel: (niveisAtivos: Set<NivelDSR>) =>
        derivarGroupingModel(
            niveisAtivos,
            ORDEM_NIVEIS_CLIENTE,
            CAMPO_POR_NIVEL,
        ),
    podeExpandirLinha: podeExpandirGrupoTerminal,
    explodirLinhas,
}

export const adaptadorDsrFuncionario: AdaptadorAgrupamentoRelatorio<
    NivelDSR,
    DescontoDSRItem,
    LinhaExplodidaDSR
> = {
    niveisValidos: ORDEM_NIVEIS_FUNCIONARIO,
    ordemNiveis: ORDEM_NIVEIS_FUNCIONARIO,
    labelNivel: LABEL_NIVEL,
    campoPorNivel: CAMPO_POR_NIVEL,
    obterGroupingModel: (niveisAtivos: Set<NivelDSR>) =>
        derivarGroupingModel(
            niveisAtivos,
            ORDEM_NIVEIS_FUNCIONARIO,
            CAMPO_POR_NIVEL,
        ),
    podeExpandirLinha: podeExpandirGrupoTerminal,
    explodirLinhas,
}
